import React from "react";

/**
 * Typographic placeholder logo for Aurevia Stones.
 * AUREVIA in tracked uppercase serif, STONES in small caps below.
 */
export const Logo = ({ size = "md", className = "" }) => {
  const sizes = {
    sm: { primary: "text-lg", secondary: "text-[9px] tracking-[0.5em]" },
    md: { primary: "text-2xl", secondary: "text-[10px] tracking-[0.5em]" },
    lg: { primary: "text-3xl", secondary: "text-[11px] tracking-[0.5em]" },
  };
  const s = sizes[size] || sizes.md;
  return (
    <a
      href="/"
      data-testid="brand-logo"
      aria-label="Aurevia Stones - Home"
      className={`group inline-flex flex-col items-start leading-none ${className}`}
    >
      <span
        className={`${s.primary} font-serif font-medium tracking-[0.32em] text-brand-gold transition-colors duration-300 group-hover:text-brand-cream`}
        style={{ fontFeatureSettings: '"liga", "dlig"' }}
      >
        AUREVIA
      </span>
      <span
        className={`${s.secondary} mt-1 font-sans uppercase font-medium text-brand-cream/60 transition-colors duration-300 group-hover:text-brand-gold/80`}
      >
        Stones
      </span>
    </a>
  );
};

export default Logo;
